import { PersonaUpdate } from "@moe/priv/model/persona";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAppContext } from "@web/route-services/root/AppContext";
import { toast } from "sonner";

/**
 * Hook for updating an existing persona
 * @returns Mutation object for updating personas
 */
export function useUpdatePersona() {
  const queryClient = useQueryClient();
  const { closeModal, access } = useAppContext();

  return useMutation({
    mutationFn: async (persona: PersonaUpdate) => {
      await access.persona.update(persona);
    },
    onSuccess: () => {
      toast.success("Successfully updated persona");
      closeModal();
      queryClient.invalidateQueries({ queryKey: ["personas"] });
    },
    onError: () => {
      toast.error("Error updating persona");
    }
  });
}
